import styled from "styled-components";
import { colors } from "../../../theme/colors";

export const Bubble = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);

  display: flex;
  justify-content: center;
  align-items: center;

  width: 3rem;
  height: 3rem;
  background-color: ${colors.primary.hex};
  border-radius: 50%;
  font-size: 1.3rem;
  color: ${colors.white.hex};
  font-weight: 600;
`;
